import React from 'react';

export default class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listVisible: false,
            display: "",
            selected: this.props.list.filter((x) => { return x.selected; })[0]
        };
        this.hideReference = this.hide.bind(this);
    }

    select(item) {
        this.setState({
            selected: item
        });
        this.props.onSelect(item);
    }

    show() {
        this.setState({ listVisible: true });
        setTimeout(() => {
            document.addEventListener("click", this.hideReference);
        }, 0);
    }

    hide() {
        this.setState({ listVisible: false });
        setTimeout(() => {
            document.removeEventListener("click", this.hideReference);
        }, 0);
    }

    render() {
        return (
            <div className={"dropdown-container " + this.props.customClass}>
                <div className={"dropdown-display " + (this.state.listVisible ? " clicked" : "")} onClick={() => this.show()}>
                    <span>{this.state.selected.name}</span>
                    <span className="pull-right glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className={"dropdown-list " + this.props.customClass + (this.state.listVisible ? "" : " hide")}>
                    <div>
                        {this.renderListItems()}
                    </div>
                </div>
            </div>
        );
    }

    renderListItems() {
        const items = [];
        for (let i = 0; i < this.props.list.length; i++) {
            let item = this.props.list[i];

            if (item === this.state.selected) {
                continue;
            }
            items.push(
                <div className="dropdown-item" onClick={() => this.select(item)} key={i}>
                    <span>{item.name}</span>
                </div>);
        }
        return items;
    }
}